import { IItemForGetShortInfo, ITotalPrice, IItemForGetShortDishInfo } from 'types';
import { IIDsShowInComboDishes } from '../../../../../../../createDishState/createDishContext';
import React from 'react';
import DishModificationCategorySelect from './components/DishModificationCategorySelect';
import DishModificationSubCategorySelect from './components/DishModificationSubCategorySelect';
import ModificationDishMultipleSelect from './components/ModificationDishMultipleSelect/ModificationDishMultipleSelect';
import DnDList from './components/DnDList';
import style from './DishModificationsField.module.scss';

interface IDishModificationsField {
	setDishModificationCategory: (value: Nullable<string>) => void;
	totalPrices: ITotalPrice[];
	setDishModificationSubCategory: (value: Nullable<string>) => void;
	setFetchedDishModificationSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedDishModificationCategory: Nullable<string>;
	setFetchedDishModifications: (value: IItemForGetShortInfo[]) => void;
	selectedDishModificationSubCategory: Nullable<string>;
	setDishModifications: (value: string[]) => void;
	selectedDishModifications: string[];
	removeDishModification: (value: string) => void;
	fetchedDishModifications: IItemForGetShortDishInfo[];
	setIDsShowInComboDishes: (value: IIDsShowInComboDishes) => void;
	IDsShowInComboDishes: IIDsShowInComboDishes;
}

const DishModificationsField: React.FC<IDishModificationsField> = ({
	totalPrices,
	setDishModificationCategory,
	selectedDishModificationCategory,
	setDishModificationSubCategory,
	setFetchedDishModificationSubCategories,
	selectedDishModifications,
	selectedDishModificationSubCategory,
	setFetchedDishModifications,
	setDishModifications,
	fetchedDishModifications,
	removeDishModification,
	setIDsShowInComboDishes,
	IDsShowInComboDishes,
}) => {
	return (
		<div className={style.container} data-test="DishModificationsField">
			<div className={style.newDishModificationFields}>
				<DishModificationCategorySelect
					totalPrices={totalPrices}
					setDishModificationCategory={setDishModificationCategory}
				/>
				<DishModificationSubCategorySelect
					selectedDishModificationCategory={selectedDishModificationCategory}
					setDishModificationSubCategory={setDishModificationSubCategory}
					setFetchedDishModificationSubCategories={setFetchedDishModificationSubCategories}
				/>
				<ModificationDishMultipleSelect
					selectedDishModifications={selectedDishModifications}
					selectedDishModificationSubCategory={selectedDishModificationSubCategory}
					setDishModifications={setDishModifications}
					setFetchedDishModifications={setFetchedDishModifications}
					setIDsShowInComboDishes={setIDsShowInComboDishes}
					IDsShowInComboDishes={IDsShowInComboDishes}
				/>
			</div>
			<DnDList
				selectedDishModifications={selectedDishModifications}
				fetchedDishModifications={fetchedDishModifications}
				setDishModifications={setDishModifications}
				removeDishModification={removeDishModification}
				IDsShowInComboDishes={IDsShowInComboDishes}
			/>
		</div>
	);
};

export default React.memo(DishModificationsField);
